<span [ngClass]="class" [hidden]="!text">{{text}}</span>
